<div class="language-wrapper">
  <span class="m-b-4"><i nz-icon nzType="global" nzTheme="outline"></i> Language: </span>
  <nz-radio-group [(ngModel)]="defaultLang" (ngModelChange)="onLanguageChanged($event)">
    <label *ngFor="let lang of languagePresets" nz-radio-button [nzValue]="lang?.value">{{ lang?.label }}</label>
  </nz-radio-group>
</div>

